module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Sachertorte-HV.e3800c70.jpg";